import sanitizeHtml from "sanitize-html";

export const removeHtml = (dirtyHtml: string | null | undefined) => {
  if (dirtyHtml === null || dirtyHtml === undefined) {
    return undefined;
  }

  const cleanedHtml = sanitizeHtml(dirtyHtml, {
    allowedTags: [],
    allowedAttributes: {},
  });

  return cleanedHtml;
};
